import script from "./FilePermitionsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilePermitionsTab.vue?vue&type=script&setup=true&lang=ts"

import "./FilePermitionsTab.vue?vue&type=style&index=0&id=fd21caec&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd21caec"]])

export default __exports__